import axiosSecure from '@api/axiosSecure';
import getContextRoot from '@api/getContextRoot';

const deleteUser = async (userId: number | string): Promise<any> => {
  const res = await axiosSecure.delete(`${getContextRoot()}/user/${userId}`);
  return res.data;
};

export default deleteUser;
